
import aosMixin from '@/mixins/aos';

export default {
  name: 'index-page',
  mixins: [aosMixin],
  data() {
    return {
      selected: 0,
      selectedPage: 0,
      dropdownConcurency: false,
      dropdownCrypto: false,
      accordions: [
        {
          title: 'Какой у вас режим работы?',
          description:
            'Будни 7:30 - 19:00. В выходные не работаем',
        },
        {
          title: 'Сколько детей в группе?',
          description:
            'У нас небольшие группы детей (5-7 человек), а значит максимальное внимание к каждому ребенку',
        },
        {
          title: 'Возможен ли у вас перерасчет по болезни?',
          description:
            'Перерасчет возможен при предоставлении справки',
        },
      ],
      pros: [
        {
          img: 'books.webp',
          title: 'Развитие',
          description:
            'Занятия, развивающие как физические, так и умственные способности малышей',
        },
        {
          img: 'tree.webp',
          title: 'Прогулки',
          description:
            'Ежедневные прогулки на свежем воздухе на огороженной территории',
        },
        {
          img: 'safe.webp',
          title: 'Безопаcность',
          description:
            'Установленные охранные системы и видеонаблюдения',
        },
      ],
      programms: [
        [
          {
            icon: 'draw.webp',
            title: 'Творчество',
            description:
              'Увлекательные занятия по рисованию, лепке, аппликации и тестопластике развивают мелкую моторику и творческое мышление',
          },
          {
            icon: 'english.webp',
            title: 'Английский язык',
            description:
              'Садик — лучшее время, чтобы начать изучение английского. Чем раньше малыш познакомится с новым языком, тем быстрее начнет свободно говорить',
          },
          {
            icon: 'fitness.webp',
            title: 'Физкультура и ЛФК',
            description:
              'Способствуют гармоничному становлению личности, делают ребенка сильным, здоровым и выносливым, а также развивают координацию',
          },
          {
            icon: 'nature.webp',
            title: 'Окружающий мир',
            description:
              'Знакомство с явлениями, предметами живой и неживой природы с помощью энциклопедий и наглядного материала. Мы даем ответы на все вопросы, которые так интересуют маленьких исследователей',
          },
          {
            icon: 'speech.webp',
            title: 'Развитие речи',
            description:
              'Формирование корректного произношения звуков, правильного дыхания и артикуляции. Улучшение понимания смыслового значения слов и грамотной формулировки предложений',
          },
          {
            icon: 'checkers.webp',
            title: 'Игры на логику',
            description:
              'Логическое мышление помогает ребенку справляться с нестандартными задачами. Мы помогаем развить его путем решения различных головоломок и ребусов, игры в шашки и шахматы',
          },
        ],
        [
          {
            icon: 'pyramid.webp',
            title: 'Монтессори',
            description:
              'Программа основана на самоуправляемой познавательной деятельности, что помогает ребенку получить необходимые научные и социальные знания и выработать умение смотреть на любые трудности с оптимизмом',
          },
          {
            icon: 'dance.webp',
            title: 'Танцы и музыка',
            description:
              'Помогают развить координацию, чувство ритма, направить энергию в нужное русло, а иногда и раскрыть таланты малыша',
          },
          {
            icon: 'toy.webp',
            title: 'Конструирование',
            description:
              'Построение из конструктора, изготовление поделок из природных материалов и игрушек из бумаги. Благодаря этому формируются представления об окружающих предметах и развивается логика',
          },
          {
            icon: 'read.webp',
            title: 'Сказкотерапия',
            description:
              'Метод психологической работы с детьми путем чтения терапевтических сказок, который помогает скорректировать поведение, избавляет от страхов и способствует здоровому психо-эмоциональному развитию',
          },
          {
            icon: 'mic.webp',
            title: 'Логоритмика',
            description:
              'Развитие речи, чувства ритма, певческих данных с помощью движений, музыки и чтения стихов. Особенно полезно малышам с нарушениями или задержками в речевом развитии',
          },
        ],
      ],
      reviews: [
        {
          name: 'Анастасия Сахарова',
          description: 'Абрикосики - наше спасение. Отдали туда дочу в 1.7, чтоб была возможность работать. Очень переживала, как она там будет без меня. ВНЕЗАПНО! Ребенок которого мне приходилось укачивать по 3 часа, засыпает в садике за 10 минут сама. Потихоньку начала разрешаться горшечная тема. Очень быстро скаканула речь и прочие умения. Проблем с нежеланием идти в садик нет. Дети все очень дружные. Доча рассказывает о них, называет имена. От силы в группе 15 человек на 3 нянечки. Все дети под присмотром. На прогулке краем уха слышала как нянечка объясняла детям что нельзя тянуть пальцы в рот, потому что там вредные микробы, а дети повторяли за ней хором. Я такой подход (объяснения) очень приветствую. Питание в садике разнообразное. Супы, салаты, фрукты, второе, горячее. Ребенок приходит из садика сытый, нагуляный и довольный. Приносит поделки. Если вдруг у ребенка случается печалька (истерика) нянечки всячески его успокаивают. Вас не дернут с работы, если внезапно ребенок соскучился по маме. Его отвлекут другими более интересными делами. Лично для меня преимущество то, что дети гуляют на обычных детских площадках, ходят кормить уточек и в ближайшие парки, а не сидят в клетушке как курочки. На дни рождения можно прям туда пригласить аниматора и детки в своем тесном кругу отпразднуют. Рекомендую этот детский сад! Останетесь довольны!',
          stars: 5,
        },
        {
          name: 'Татьяна Мамонтова',
          description: 'Здравствуйте наши ЛЮБИМЫЕ АБРИКОСИКИ! (так доча вас называет,когда проходим мимо вашего садика).Помнится,я вам обещала отзыв написать,но закрутилась и забыла...Пришли мы к вам совсем крохотные (1,5 г). Поэтому и выбирали садик с малым количеством деток. На уровне первого знакомства с садиком и собеседования с заведующей,я поняла-это МОЁ! Далее как по маслу--грамотная адаптация,где мы на третий день уже остались со сном! сама не верила,боялась,но решилась)).Особая благодарность,что отучили дочу от соски! С питанием у нас не было проблем,поэтому она у вас все и съедала,еще и добавку всегда просила)). Очень радует,что приучили всех к салату с капустой,луком и огурцом,Соня до сих пор обожает этот полезный салат).Как то заходила к вам во время обеда - приборы чистые, всё аккуратно, деткам ротики вытирают, после еды все чистенькие. Воспитатели чуткие, добрые, когда заходила за дочуркой наблюдала, как по доброму и спокойно они разговаривают с детьми - не прикрикнут, но и не сюсюкаются, детки их слушаются! Спасибо Ангелине за всякие поделки,за её терпение и тяжкий труд! да-да---это тяжкий труд,ведь мы иногда устаем от одного своего ребенка,а они с Кристиной справляются со всей оравой ребятишек!) Помимо фото/видео отчётов, мы и дома видели, как взрослеет и меняется наш ребёнок! В гос саду нам уже не нужна была адаптация и пригодились все навыки развития нашей дочурки в АБРИКОСИКАХ! Спасибо вам за вашу доброту души и любовь к детям!',
          stars: 5,
        },
        {
          name: 'Евгения Тихонова',
          description: 'Отдали дочку в 1.8. Думали походить несколько месяцев для социальной адаптации. Адаптация супер мягко прошла. Ребёнок каждый день с радостью собирается в сад. Развитие колоссальное наблюдаем. Каждый день разные тематические занятия, зарядка, постановка танцев, праздничные утренники, лфк, интересные игры,английский, выступления, песни, стихи и танцы. Прогулки на свежем воздухе с интересной программой. Много внимания и заботы.Ежедневные фотографии времяпровождения деток.Очень вкусное 5 разовое питание. Не большая группа.Ирина Алексеевна, Ангелина,Кристина- это воспитатели от Бога, с большим и добрым сердцем и любящие детей. Которые вкладывают знания, любовь и доброту в моего ребёнка. Нам очень повезло ,что так сложилось и мы ходим в Абрикосики. Спасибо, воспитателям. Рекомендую этот сад!!!',
          stars: 5,
        },
        {
          name: 'Наталья Федюра',
          description: 'Посещали наш любимый сад год. Дочь очень быстро адаптировалась и шла туда с удовольствием. Мне, как маме, очень понравился индивидуальный подход: воспитатели знали и учитывали и предпочтения в еде, и возможности ребенка. Мой ребенок именно там научилась творчеству (вырезать, клеить, собирать аппликации и т.д.) . Ушли оттуда лишь потому, что дали место в гос.саду. В нашем новом саду отметили, что моя дочь очень хорошо подготовлена к пребыванию в коллективе. Очень благодарны Олесе, Ангелине и, конечно же, Ирине Алексеевне! Очень советую остановить свой выбор именно на этом садике, не пожалеете!',
          stars: 5,
        },
        {
          name: '​kammet24',
          description: 'Как же нам повезло!Когда пришла знакомиться сразу почувствовала тёплое отношение к детям со стороны персонала.Главные критерии моего выбора: количество детей ,качество еды,развивающее занятия, аккуратность и самое важное это конечно душа!(а она там есть). Вообщем всегда чистенькая,веселая и сытая.Очень быстро адаптировались,стала ходить на горшок,научилась играть с другими детками и самостоятельно.Сегодня с окна наблюдала как гуляли ребятишки!Как задорно воспитали играли в догонялки,дети счастливы и я конечно тоже.',
          stars: 5,
        },
        {
          name: '​Марина Джупина',
          description: 'В данный сад ходим с весны 2020 года, ребёнку было 1,4.До этого ходили в другой детский сад, ничего плохо сказать не могу, было видео наблюдение онлайн, но ребёнок приходил домой голодный,бежала сразу к холодильнику. Здесь доча сытая приходит и с удовольствием ходит в этот сад. Утром встаёт со слов, что уже в садике каша готова надо идти, сразу просыпается и бежит одеваться. Любит очень воспитателей Ангелину и Кристину. Огромное спасибо Вам за Ваш труд и отношение любящее к нашим деткам.',
          stars: 5,
        },
        {
          name: 'Оксана Жартун',
          description: 'Дочка с удовольствием ходила в этот сад. Хоть мы два месяца уже не ходим, до сих пор вспоминает. Группы маленькие, индивидуальный подход к ребенку. Кормят хорошо, всегда дополнительные порции, возможна адаптация меню для аллергиков. Воспитатели при приеме сразу просят принести спортивную форму - для занятий ЛФК. Вечером ребенок уходить не хотел, а с утра спешил, в "любимый Абрикосик".',
          stars: 5,
        },
        {
          name: 'Анастасия Шиленко',
          description: 'Замечательный садик, рекомендую! Отдала в "Абрикосики" дочку в январе 2020, ей было на тот момент 1, 5 года. Ребенок быстро начал оставаться на полный день. Забирала ее по вечерам радостную, энергичную; частенько она не хотела даже уходить :) Отдельно хочу отметить, что ее там быстро научили ходить на горшок (я не могла с этим справиться). Также она научилась правильно держать карандаш и ложку, мыть и вытирать руки, улучшила свои навыки одевания и застегивания одежды. Делали там милые поделки -- аппликации и из соленого теста. Атмосфера в садике спокойная и дружелюбная; когда забирала дочку, видела других детей -- все весело играют, общаются между собой, если плачут -- то только по делу :) Воспитатели добрые, дружелюбные и спокойные. Отвечают на все вопросы касательно ребенка. Очень жаль, что не сможем продолжить посещать этот сад (пришлось переехать).',
          stars: 5,
        },
        {
          name: 'Ната',
          description: 'Добрый день! Хочу выразить огромную благодарность персоналу детского сада! Мы очень довольны, что выбрали именно ваш детский сад. У меня была большая проблема с прогулками, я как сумасшедшая мамочка боялась оставлять своего ребенка на прогулку )))) потому что ну уж очень мы шустрые )))) Спасибо вам огромное, теперь доверяю полностью)))) знаю, что за детьми следят. Спасибо!',
          stars: 5,
        },
        {
          name: '​oafanaseva89',
          description: 'Начали ходить в этот садик. Пока все нравится. Очень отзывчивые воспитатели, вкусно кормят (так ребенок говорит). Очень радует, что мало детей в группе. Больше внимания, меньше болеть будут. Да и в целом нас все устроило. Выбирали сад по принципу, где группы меньше. Каждый день что-то делают, завели папку для поделок (как воспитатели сказали)))',
          stars: 5,
        },
      ],
      deviceSizes: {
        xs: 440,
        sm: 992,
        md: 1100,
        lg: 1200,
        xl: 1400,
      },
      prices: {
        abonements: [
          {
            name: 'Абонемент',
            time: '07:30-12:00',
            money: '8 000 руб/мес',
          },
          {
            name: 'Абонемент',
            time: '07:30-19:00',
            money: '14 000 руб/мес',
          },
        ],
        days: [
          {
            name: 'Дневное пребывание',
            time: '07:30-12:00',
            money: '450 руб/сут',
          },
          {
            name: 'Дневное пребывание',
            time: '07:30-19:00',
            money: '800 руб/сут',
          },
        ],
        additional: [
          {
            name: 'Адаптация',
            time: '',
            money: '150 руб/час',
          },
        ],
      },
      pricess: [
        {
          name: 'Абонемент (неполный день)',
          time: '07:30-12:00',
          money: '8 000 руб/мес',
        },
        {
          name: 'Абонемент (полный день)',
          time: '07:30-19:00',
          money: '14 000 руб/мес',
        },
        {
          name: 'Дневное пребывание (до сна)',
          time: '07:30-12:00',
          money: '450 руб/сут',
        },
        {
          name: 'Дневное пребывание (до вечера)',
          time: '07:30-19:00',
          money: '800 руб/сут',
        },
        {
          name: 'Адаптация',
          time: '',
          money: '150 руб/час',
        },
      ],
    };
  },
  methods: {
    nextPage(ind) {
      const width = window.innerWidth;
      // eslint-disable-next-line no-nested-ternary
      const breakpoint = width <= this.deviceSizes.xs ? 360 : width <= this.deviceSizes.sm ? 850 : width <= this.deviceSizes.md ? 970 : width <= this.deviceSizes.lg ? 1070 : width <= this.deviceSizes.xl ? 1250 : 1250;
      const step = breakpoint + 30;
      this.$refs.slider.scrollLeft = this.selectedPage > ind 
        ? this.$refs.slider.scrollLeft - step * (this.selectedPage - ind) 
        : this.$refs.slider.scrollLeft + step * (ind - this.selectedPage);
      this.selectedPage = ind;
    },
  },
};
